import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { useIsMobile } from "../../hooks";
import { LoginStore } from "../../store/login";
import { OrgAPI } from "src/api";
import { OrgStore } from "src/store";

import { OrgLogo } from "./org_logo";

const OrgWrapper = ({ children }) => {
  const isSingleOrgEnv = !!window.context?.isSingleOrgEnv;
  const { orgIdentifier } = useParams();
  const isOrgSpecificPage = !!orgIdentifier;
  const history = useHistory();
  const dispatch = useDispatch();

  const orgs = useSelector(OrgStore.selectors.selectAll());
  const org = isSingleOrgEnv ? orgs[0] : orgs.find((o) => o.short_name === orgIdentifier);

  // Fetch org data if we don't already have it
  useEffect(() => {
    // Multi-org environment and non-org specific page (no need to fetch the org)
    if (!isSingleOrgEnv && !isOrgSpecificPage) return;

    // Org has been fetched already
    if (org) return;

    async function fetchOrgData() {
      const orgData = await dispatch(OrgAPI.fetchOrgs({ orgIdentifier }));
      if (!orgData.data.length) {
        // Unknown org, redirect to org input page
        history.push(`/sso`);
      }
    }
    fetchOrgData();
  }, [isSingleOrgEnv, isOrgSpecificPage, org, orgIdentifier, dispatch, history]);

  const isMobile = useIsMobile();
  const cookieBannerIsShowing = useSelector(LoginStore.selectors.select("cookieBannerIsShowing"));

  return (
    <div
      style={{ height: `calc(100vh - ${cookieBannerIsShowing ? "72px" : "0px"})` }}
      className="flex column"
    >
      <OrgLogo minervaLogo={!isOrgSpecificPage} orgId={org?.id} />
      <div id="js-login-form" className={`self-center ${isMobile ? "mx5 full-width" : "mx-auto"}`}>
        <div
          className="flex flex-column items-center"
          style={{ width: isMobile ? "inherit" : "400px" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export { OrgWrapper };
